import { useState, type ReactNode } from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { Button } from '@/components/ui/button';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { JsonView, defaultStyles, darkStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

interface CollapsibleSectionProps {
  title: string;
  data: unknown;
  defaultOpen?: boolean;
  badge?: ReactNode;
}

export function CollapsibleSection({
  title,
  data,
  defaultOpen = false,
  badge
}: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  // Detect dark mode
  const isDark = document.documentElement.classList.contains('dark');
  const jsonStyles = isDark ? darkStyles : defaultStyles;

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger asChild>
        <Button variant="ghost" className="w-full justify-start gap-2 px-4 py-2 h-auto">
          {isOpen ? (
            <ChevronDown className="h-4 w-4" />
          ) : (
            <ChevronRight className="h-4 w-4" />
          )}
          <span className="font-medium">{title}</span>
          {badge && <span className="ml-auto">{badge}</span>}
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="px-4 py-2">
          <JsonView
            data={data}
            shouldExpandNode={(level) => level < 2}
            style={jsonStyles}
          />
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
